import { createContext } from 'react';
export var IndexContext = /*#__PURE__*/createContext(null);

if (process.env.NODE_ENV !== 'production') {
  IndexContext.displayName = 'Index';
}